"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSearchL1CategoryGroupedOptions = void 0;
const ramda_1 = require("ramda");
const client_constants_1 = require("../../../client/client.constants");
const getLowerLabel = ({ label }) => label.toLowerCase();
const getValue = ({ value }) => value;
const getMaxScore = ({ maxScore }) => maxScore;
const getScore = ({ score }) => score;
const sortGroupsByRelevance = (0, ramda_1.sortWith)([
    (0, ramda_1.descend)(getMaxScore),
    (0, ramda_1.ascend)(getLowerLabel),
    (0, ramda_1.ascend)(getValue),
]);
const sortChildrenByRelevance = (0, ramda_1.sortWith)([
    (0, ramda_1.descend)(getScore),
    (0, ramda_1.ascend)(getLowerLabel),
    (0, ramda_1.ascend)(getValue),
]);
const buildSearchL1CategoryGroupedOptions = (records = []) => {
    const map = new Map();
    records
        .filter(({ score }) => score > client_constants_1.SEARCH_THRESHOLD)
        .forEach(({ productTreeNode, score }) => {
        var _a, _b;
        const ancestors = productTreeNode.ancestors.edges;
        const secondAncestor = (_b = (_a = ancestors[1]) === null || _a === void 0 ? void 0 : _a.node) === null || _b === void 0 ? void 0 : _b.ancestor;
        if (!secondAncestor)
            return;
        const parentId = secondAncestor.id;
        const parentTitle = secondAncestor.title;
        if (!map.has(parentId)) {
            map.set(parentId, {
                label: parentTitle,
                value: parentId,
                children: [],
                maxScore: score,
            });
        }
        const parent = map.get(parentId);
        if (!parent)
            return;
        parent.maxScore = Math.max(parent.maxScore, score);
        parent.children.push({
            label: productTreeNode.title,
            value: productTreeNode.id,
            score,
        });
    });
    return sortGroupsByRelevance(Array.from(map.values()))
        .map(({ label, value, children }) => ({
        label,
        value,
        children: sortChildrenByRelevance(children)
            .map(({ label: childLabel, value: childValue }) => ({
            label: childLabel,
            value: childValue,
        })),
    }));
};
exports.buildSearchL1CategoryGroupedOptions = buildSearchL1CategoryGroupedOptions;
